/* Read the same Shopify-rendered cards used by advertising results and kit browsing. */
(function(){
 'use strict';
 let pending;
 async function page(number){
  const response=await fetch('/collections/cctv-kits?view=ccgridall&sort_by=best-selling&page='+number,{signal:AbortSignal.timeout(25000)});
  if(!response.ok)throw Error('Product cards could not be loaded. Try again.');
  const doc=new DOMParser().parseFromString(await response.text(),'text/html'),grid=doc.querySelector('[data-ccg]');
  if(!grid)throw Error('The shared product grid is unavailable.');
  return {total:Number(grid.dataset.count)||0,cards:[...grid.querySelectorAll('.crc')]};
 }
 function load(){
  if(!pending)pending=(async()=>{
   const first=await page(1),pages=Math.min(9,Math.ceil(first.total/50)),rest=await Promise.all(Array.from({length:Math.max(0,pages-1)},(_,i)=>page(i+2)));
   return new Map([first,...rest].flatMap(result=>result.cards).flatMap(card=>{
    const id=card.dataset.productId||card.querySelector('[data-product-id]')?.dataset.productId;return id?[[id,card]]:[];
   }));
  })().catch(error=>{pending=null;throw error;});
  return pending;
 }
 function clone(cards,id,{local=false,api='/api'}={}){
  const source=cards.get(String(id));if(!source)return null;
  const card=source.cloneNode(true);card.dataset.kitId=id;card.querySelectorAll('script').forEach(script=>script.remove());
  if(local)window.SMKPreviewCards?.prepare(card,api);
  return card;
 }
 window.SMKSharedKitCards={load,clone};
})();
